<script>
import resetPasswordModal from "@/components/resetPasswordModal";

export default {
  name: "login-form",
  components: {
    resetPasswordModal,
  },
  data: function() {
    return {
      email: "",
      password: "",
      isResetModalShown: false,
    };
  },
  methods: {
    async attemptLogin() {
      await this.$store.dispatch("login", { email: this.email, password: this.password });
    },

    clearError: function() {},
    onKeyup: function(event) {
      if (event.key == "Enter") {
        this.attemptLogin();
      } else {
        this.clearError();
      }
    },
    onResetPasswordClick: function() {
      this.$store.commit("toggleResetPasswordModal", true);
    },
  },
  computed: {
    isLoginError: function() {
      return this.$store.state.isLoginError;
    },
    canLogin: function() {
      return this.email && this.password;
    },
  },
};
</script>
<template>
  <div class="full-page">
    <div style="position:relative;padding:15px;text-align:center;" class="centered">
      <div>
        <div class=" offset-lg-4 col-lg-4  offset-md-2 col-md-8 col-sm-12" style="background-color:rgba(255, 255, 255, 0.4);padding-top:15px;padding-bottom:15px;">
          <img style="width:250px;margin-bottom:2rem" src="@/assets/images/logo-02-sea.png" />
          <div style="padding-left:0.5rem;padding-right:0.5rem">
            <form autocomplete="off">
              <div class="row" style="margin-bottom:0.5rem;">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"><i class="far fa-envelope" style="color:white"></i></span>
                  </div>
                  <input v-model="email" class="form-control mr-sm-2" type="text" placeholder="Email" aria-label="Email Address" v-on:keyup="onKeyup" />
                </div>
              </div>
              <div class="row" style="margin-bottom:0.5rem;">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-key" style="color:white"></i></span>
                  </div>
                  <input v-model="password" class="form-control mr-sm-2" type="password" placeholder="Password" aria-label="Password" v-on:keyup="onKeyup" />
                </div>
                <div style="position:absolute;bottom:-10px;left:0px;" v-if="isLoginError"><i class="errorText">Unable to verify login details</i></div>
              </div>
              <div class="row">
                <div class="input-group">
                  <button :disabled="!canLogin" style="color:#004996;width:100%" class="btn btn-light login-button" type="button" v-on:click="attemptLogin">
                    <span class="login-button-content">Login<i class="fas fa-sign-in-alt icon-right"></i></span>
                  </button>
                </div>
              </div>

              <div style="clear:both"></div>
            </form>
            <div class="row">
              <div class="col-12">
                <div style="width:100%;text-align:center;color:white"><span class="reset-password" v-on:click="onResetPasswordClick">Reset Password</span></div>
              </div>
            </div>
            <reset-password-modal></reset-password-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#loginError {
  display: none;
}
.bg-light {
  background-color: white;
  -webkit-box-shadow: 7px 3px 9px -5px rgba(0, 0, 0, 0.57);
  -moz-box-shadow: 7px 3px 9px -5px rgba(0, 0, 0, 0.57);
  box-shadow: 7px 3px 9px -5px rgba(0, 0, 0, 0.57);
}

.full-page {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background: rgb(0, 73, 150);
  background: radial-gradient(circle, rgba(0, 73, 150, 1) 0%, rgba(0, 180, 227, 1) 100%);
}
.centered {
  margin: 0;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.mr-sm-2,
.mx-sm-2 {
  margin-right: 0px !important;
}
input[type="text"],
input[type="search"],
input[type="password"],
input[type="email"],
input[type="file"],
input[type="number"],
input[type="tel"],
textarea,
select,
input:-webkit-autofill,
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  background-color: transparent !important;
  -webkit-box-shadow: none;
  -webkit-text-fill-color: white;
  transition: background-color 5000s ease-in-out 0s;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
}
.input-group-text {
  background: none;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
}
input {
  border-top: 0px !important;
  border-right: 0px !important;
  border-left: 0px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
  color: white;
}
::placeholder {
  color: white;
}
</style>
